import React, { Component } from "react";
import Header from "../../components/header";
import Footer from "../../components/footer";
import HELPERS from "../../utils/helper";
import apis from "../../config/apis";
import { withRouter } from "react-router-dom";
import { colors } from "../../css/colors";
import { connect } from "react-redux";
import OfferTag from "../../assets/discount.png";
import CONFIG from "../../config";
import {
  ToastMessage,
  Toast,
  toastMsgConfig,
  toastTypes,
} from "../../components/toast";
import ErrorPage, { ErrorMessageHandling } from "../../components/error";
import { imageURL, product_video_responsive } from "../../utils/constants";
import ReactPlayer from "react-player";
import Carousel from "react-multi-carousel";
import play from "./../../assets/play_video.png";
import pause from "./../../assets/pause_video.png";
import axios from "axios";
import {
  RiDownload2Line,
} from "react-icons/ri";
import { getAdminToken } from "../../utils/tokenManager";
import { getInstalmentSchedule, initiateInstalmentPayment } from "../myOrders/instalmentPayment";
import { getPaymentGatewayChecking } from "../cart/payment";
import InstalmentSchedule from "../../components/instalmentSchedule";

class ProductDesc extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: true,
      success: false,
      loader3: false,

      loader1: true,
      success1: false,

      desc: [],
      liveClasses: [],
      product: {},
      videos: [],
      currVideoIndex: 0,
      playing: false,
      show_product_image_only: true,
      send_consumption: 0,

      instalmentPlan: [],
      isInstalmentProduct: false,
      instalmentPlanExpanded: true,
      selectedInstalments: [1],

      // Payment gateway state (for instalment payments)
      paymentLoader: false,
      public_token: "",
      is_oAuth_done: "",
      gatewayDta: {},
      expandedItems: {}, // Track which items are expanded
      expandedLiveClasses: {}, // Track which live classes are expanded
    };
  }

  toggleItemExpansion = (index) => {
    this.setState((prevState) => {
      const newExpandedItems = {
        ...prevState.expandedItems,
        [index]: !prevState.expandedItems[index],
      };
      return { expandedItems: newExpandedItems };
    });
  };

  toggleLiveClassExpansion = (index) => {
    this.setState((prevState) => {
      const newExpandedLiveClasses = {
        ...prevState.expandedLiveClasses,
        [index]: !prevState.expandedLiveClasses[index],
      };
      return { expandedLiveClasses: newExpandedLiveClasses };
    });
  };

  componentDidMount = () => {
    window.scrollTo(0, 0);
    this.getProdDesc();
    getPaymentGatewayChecking(
      this.props,
      () => {},
      this.updateGatewayData
    );
  };

  updateGatewayData = (data) => {
    this.setState({
      public_token: data?.Razorpay?.public_token || data?.public_token,
      is_oAuth_done: data?.Razorpay?.is_oAuth_done || data?.is_oAuth_done,
      gatewayDta: data,
    });
  };

  message = (type, message) => {
    Toast(message, toastMsgConfig(type));
  };

  getYoutubeVideoId = (url) => {
    url = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    return url[2] !== undefined ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
  };

  handlePlayYoutubeAndMp4 = (el, id) => {
    const {
      loader,
      product,
      desc,
      success,
      loader1,
      success1,
      videos,
      currVideoIndex,
      playing,
      send_consumption,
    } = this.state;
    if (el?.type === "video_url") {
      if (!send_consumption && el.url) {
        this.calculateCloudConsumption(el.url, el, id);
      } else {
        this.setState({
          show_product_image_only: false,
          currVideoIndex: id,
          playing: currVideoIndex === id ? !playing : true,
          send_consumption: send_consumption + 1,
        });
      }
    } else {
      this.setState({
        show_product_image_only: false,
        currVideoIndex: id,
        playing: currVideoIndex === id ? !playing : true,
      });
    }
  };

  calculateCloudConsumption = async (aws_video_url, el, id) => {
    // Deduct Consumption via calling API only for aws-videos and for 1st time play only
    const {
      loader,
      product,
      desc,
      success,
      loader1,
      success1,
      videos,
      currVideoIndex,
      playing,
      send_consumption,
    } = this.state;
    const { location, institute_id } = this.props;
    const initials =
      CONFIG.PRODUCT_BASE_URL +
      "prod/product/update-consumed-storage?videoUrl=";
    let url = initials + aws_video_url;
    const customHeaders = this.generateAuthHeaders(this.props.institute_id);

    const headers = {
      ...customHeaders,
      "x-prod-inst-id": institute_id,
      "x-prod-user-id": undefined,
    };
    let body = {};
    this.setState({ loader3: true });
    await axios
      .put(url, body, { headers: headers })
      .then((res) => {
        this.setState({ loader3: false });
        this.setState({
          show_product_image_only: false,
          currVideoIndex: id,
          playing: currVideoIndex === id ? !playing : true,
          send_consumption: send_consumption + 1,
        });
      })
      .catch((error) => {
        this.setState({ loader3: false });
        if (error.response && error.response.status === 403) {
          this.props.dispatch({
            type: "LOGOUT",
            message:
              error.response.data && error.response.data.message
                ? error.response.data.message
                : "",
          });
        } else if (
          error.response &&
          error.response.data &&
          error.response.data.error &&
          Array.isArray(error.response.data.error) &&
          error.response.data.error.length > 0
        ) {
          this.message("e", error.response.data.error[0].error_message);
        } else {
          this.message("e", ErrorMessageHandling(error));
        }
      });
  };

  getProdDesc = async () => {
    const { location, institute_id, user_id } = this.props;
    const customHeaders = this.generateAuthHeaders(this.props.institute_id);
  
    let headers = {
      headers: {
        ...customHeaders,
        "x-prod-inst-id": institute_id,
        "x-prod-user-id": user_id,
      },
    };
  
    try {
      let data = await HELPERS.ApiCall(
        apis.PRODUCT_DETAILS +
          location.state.item.id +
          "?is_meta_data_req=true",
        {},
        "GET",
        "product",
        headers
      );
  
      // ✅ ONLY CHECK HTTP STATUS
      if (data.status === 200) {
        const apiResult = data?.data?.result;
  // console.log("here",data.data.status_code)
        // ✅ NORMAL SUCCESS CASE
        if (data.data.status_code === 200 && apiResult) {
          // console.log("hi")
          if (Array.isArray(apiResult) && apiResult.length) {
            let temp = [];
            let el = apiResult[0];
  
            if (el.youtube_url) {
              let temp_youtube_url_list = JSON.parse(el.youtube_url);
              temp_youtube_url_list.forEach((item) => {
                temp.push({
                  url: item,
                  type: "youtube_url",
                  thumbnail:
                    "https://img.youtube.com/vi/" +
                    this.getYoutubeVideoId(item) +
                    "/0.jpg",
                });
              });
            }
  
            if (el.video_url) {
              let extension = el.video_url.split(".").pop().trim();
              extension === "mp4"
                ? temp.push({
                    url: el.video_url,
                    type: "video_url",
                    format: extension,
                  })
                : temp.push({ url: el.video_url, type: "video_url" });
            }
  
            this.setState({ videos: temp });
          }
  
          if (location.state.item.from_direct_url) {
            this.getProdDetails();
          } else {
            this.setState({ loader1: false, success1: true });
            this.fetchInstalmentPlan(location.state.item);
          }
  
          let itemList = [];
          if (apiResult?.item_list && Array.isArray(apiResult.item_list)) {
            itemList = apiResult.item_list;
          } else if (Array.isArray(apiResult)) {
            itemList = apiResult;
          }
  
          let liveClassList = [];
          if (
            apiResult?.live_class_list &&
            Array.isArray(apiResult.live_class_list)
          ) {
            liveClassList = apiResult.live_class_list;
          }
  
          this.setState({
            loader: false,
            desc: itemList,
            liveClasses: liveClassList,
            success: true,
            product: location.state.item,
          });
        }
        // ✅✅✅ NO PRODUCT ITEMS FOUND (YOUR MAIN ISSUE FIXED HERE)
        else if (
          data.data.status_code === 400 
        ) {
          console.log("400")
          console.warn("No product items found — loading empty state");
  
          this.setState({
            loader: false,
            loader1: false,
            desc: [],
            liveClasses: [],
            videos: [],
            success: true,       
            success1: true,       
            product: location.state.item,
          });
          
        }
  
        // ❌ REAL ERROR CASE
        else {
          this.setState({ loader: false, success: false, loader1: false });
          this.message("e", data?.data?.message || "Something went wrong");
        }
      }
    } catch (error) {
      if (error.response && error.response.status === 403) {
        this.props.dispatch({
          type: "LOGOUT",
          message:
            error.response.data && error.response.data.message
              ? error.response.data.message
              : "",
        });
      } else if (
        error.response &&
        error.response.status === 400 &&
        error.response.data &&
        error.response.data.status_code === 400
      ) {
        // No product items found — show product page with empty content
        const { location } = this.props;
        this.setState({
          loader: false,
          loader1: false,
          desc: [],
          liveClasses: [],
          videos: [],
          success: true,
          success1: true,
          product: location.state.item,
        });
        if (location.state.item.from_direct_url) {
          this.getProdDetails();
        } else {
          this.fetchInstalmentPlan(location.state.item);
        }
        return;
      } else if (
        error.response &&
        error.response.data &&
        error.response.data.error &&
        Array.isArray(error.response.data.error) &&
        error.response.data.error.length > 0
      ) {
        this.message("e", error.response.data.error[0].error_message);
      } else {
        this.message("e", ErrorMessageHandling(error));
      }

      this.setState({ loader: false, success: false, loader1: false });
    }
  };
  
  generateAuthHeaders = (instit_id) => {
    // Step 1: Add a constant
    const constantAdd = 22374;
    const step1 = instit_id + constantAdd;
  
    // Step 2: Multiply by a prime constant
    const constantMultiply = 57;
    const step2 = step1 * constantMultiply;
  
    // Step 3: XOR with another constant
    const constantXOR = 546348970;
    const step3 = step2 ^ constantXOR;
  
    // Step 4: Generate a random 5-digit number once
    const secondaryAdd = Math.floor(10000 + Math.random() * 90000); // random 5-digit number
  
    // Final transformation
    const transformedNumber = step3 + secondaryAdd;
  
    // Return headers
    return {
      "session-id": secondaryAdd.toString(),          // same as random 5-digit number
      // "x-prod-inst-id" : institute_id.toString(),
      "x-proc-authorization" : transformedNumber.toString()
    };
  };
  getProdDetails = async () => {
    const { location } = this.props;
    const customHeaders = this.generateAuthHeaders(this.props.institute_id);

    // 2. Merge with Authorization
    const headers = {
      headers: {
      ...customHeaders,
      "x-prod-inst-id": this.props.institute_id,

      // Authorization:
      //   this.props.user_id == 0
      //     ? getAdminToken()
      //     : this.props.student_auth,
    }};
    let url = `${apis.PRODUCT_INFO}?proc=${location.state.item.title}%23$${location.state.item.id}%23$${location.state.ins_id}`;
    try {
      let data = await HELPERS.ApiCall(url, {}, "GET", "product",headers);
      if (data.status === 200 && data.data.status_code === 200) {
        const apiProduct = data.data.result[0];
        if (!apiProduct.c_code && apiProduct.country_details?.currency_code) {
          apiProduct.c_code = apiProduct.country_details.currency_code;
        }
        const fetchedProduct = { ...this.state.product, ...apiProduct };
        this.setState({
          loader1: false,
          product: fetchedProduct,
          success1: true,
        });
        this.fetchInstalmentPlan(fetchedProduct);
      } else {
        this.setState({ loader1: false, success1: false });
        this.message("e", data.data.message);
      }
    } catch (error) {
      if (error.response && error.response.status === 403) {
        this.props.dispatch({
          type: "LOGOUT",
          message:
            error.response.data && error.response.data.message
              ? error.response.data.message
              : "",
        });
      } else if (
        error.response &&
        error.response.data &&
        error.response.data.error &&
        Array.isArray(error.response.data.error) &&
        error.response.data.error.length > 0
      ) {
        this.message("e", error.response.data.error[0].error_message);
      } else {
        this.message("e", ErrorMessageHandling(error));
      }
      this.setState({ loader1: false, success1: false });
    }
  };

  fetchInstalmentPlan = async (product) => {
    const { institute_id, site_data, user_id, student_auth } = this.props;
    const enableInstalment = site_data && site_data.enable_instalment_payment;
    // const enableInstalment = false;
    // console.log("en",enableInstalment)

     // hardcoded for local dev; use site_data.enable_instalment_payment in prod
    const productId = product.product_id || product.id;
    if (!enableInstalment) {
      return;
    }
    try {
      const params = {
        productId,
        institute_id,
        user_id: user_id == 0 ? "" : user_id,
        generateAuthHeaders: this.generateAuthHeaders,
      };
      // If user is logged in, also pass user auth for user-specific schedule
      if (user_id && user_id !== 0 && student_auth) {
        params.student_auth = student_auth;
      }
      const result = await getInstalmentSchedule(params);
      const plan = result.user_instalments || result.product_instalments || result || [];
      // For purchased products, pre-select the first pending instalment
      let initialSelections = [1];
      if (product.is_enrolled) {
        const firstPendingIdx = plan.findIndex(
          (inst) => inst.status === 10 || inst.status === 30
        );
        initialSelections = firstPendingIdx !== -1 ? [firstPendingIdx + 1] : [];
      }

      this.setState({
        instalmentPlan: plan,
        isInstalmentProduct: true,
        selectedInstalments: initialSelections,
      });
    } catch (err) {
      // Failed to fetch instalment plan
    }
  };

  handlePayInstalment = async (selectedInstalments, totalAmount) => {
    const { product } = this.state;
    const { public_token, is_oAuth_done, gatewayDta } = this.state;
    const productId = product.product_id || product.id;

    if (!selectedInstalments || selectedInstalments.length === 0) {
      this.message("e", "Please select at least one instalment to pay.");
      return;
    }

    this.setState({ paymentLoader: true });

    try {
      await initiateInstalmentPayment({
        productId,
        selectedInstalments,
        totalAmount,
        props: this.props,
        gatewayData: gatewayDta,
        public_token,
        is_oAuth_done,
        c_symbol: product.c_code || "INR",
        country_id: product.country_details?.country_id || this.props.country_details?.country_id || null,
        onSuccess: () => {
          this.setState({ paymentLoader: false });
          // Re-fetch instalment schedule to update statuses
          this.fetchInstalmentPlan(product);
        },
        onFailure: () => {
          this.setState({ paymentLoader: false });
        },
        setLoader: (val) => this.setState({ paymentLoader: val }),
        message: this.message,
      });
    } catch (error) {
      this.setState({ paymentLoader: false });
      const errMsg =
        error?.response?.data?.message || error.message || "Failed to initiate payment";
      this.message("e", errMsg);
    }
  };

  addToCart = (item, from_direct_url) => {
    let id = from_direct_url ? item.product_id : item.id;
    const { cart, site_data } = this.props;
    const enableInstalment = site_data && site_data.enable_instalment_payment;
    const isInstalment = enableInstalment && this.state.isInstalmentProduct;

    if (isInstalment && cart && cart.length > 0 && !cart.includes(id)) {
      this.message("e", "Instalment products can only be purchased individually. Please remove other products from cart first.");
      return;
    }
    if (!isInstalment && enableInstalment && cart && cart.length > 0) {
      const { instalmentSelections } = this.props;
      if (instalmentSelections && Object.keys(instalmentSelections).length > 0) {
        this.message("e", "Your cart contains an instalment product. Please complete that purchase first or remove it to add other products.");
        return;
      }
    }

    if (!cart.includes(id)) {
      this.props.dispatch({
        type: "ADD_TO_CART",
        payload: {
          id: [id, ...cart],
        },
      });
    }
    if (isInstalment && this.state.selectedInstalments.length > 0) {
      this.props.dispatch({
        type: "SET_INSTALMENT_SELECTION",
        payload: {
          productId: item.entity_id || id,
          selectedInstalments: this.state.selectedInstalments,
        },
      });
    }
  };

  removeFromCart = (item, from_direct_url) => {
    let id = from_direct_url ? item.product_id : item.id;
    this.props.dispatch({
      type: "REMOVE_FROM_CART",
      payload: {
        id: id,
      },
    });
  };

  render() {
    const {
      loader,
      product,
      desc,
      liveClasses,
      success,
      loader1,
      success1,
      videos,
      currVideoIndex,
      playing,
      send_consumption,
      loader3,
      paymentLoader,
      expandedItems,
      expandedLiveClasses,
    } = this.state;
    const { cart, location, institute_id } = this.props;
    let from_direct_url = location.state.item.from_direct_url;

    // Product Details section is shown only for institute 102039; hidden for all other institutes
    const showProductDetails = Number(institute_id) === 102039;

    // Filter live classes to show only from today to 7 days ahead
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const rangeEnd = new Date(today);
    rangeEnd.setDate(rangeEnd.getDate() + 7);
    rangeEnd.setHours(23, 59, 59, 999);
    const filteredLiveClasses = (liveClasses || []).filter((lc) => {
      if (!lc.start_datetime) return false;
      const classDate = new Date(lc.start_datetime);
      return classDate >= today && classDate <= rangeEnd;
    });

    return (
      <>
        <ToastMessage />
        <Header />
        {!loader && success && !loader1 && success1 && !loader3 && (
          <div
            className="content bgimg2"
            style={{ paddingTop: 100, paddingBottom: 30 }}
          >
            {/* Top Section: Image and Product Info */}
            <div className="productDesc">
              <div className="productDescLeft">
                {videos.length && this.state.show_product_image_only ? (
                  <img
                    className="product_video_player"
                    style={{
                      width: "32vw",
                      maxWidth: "550px",
                      objectFit: "contain",
                    }}
                    src={
                      product.logo_url === undefined
                        ? product.product_logo_url === undefined
                          ? imageURL
                          : product.product_logo_url
                        : product.logo_url
                    }
                  />
                ) : (
                  ""
                )}
                {videos.length ? (
                  <div>
                    {!this.state.show_product_image_only && (
                      <div>
                        {(videos[currVideoIndex]?.format &&
                          videos[currVideoIndex]?.format === "mp4") ||
                        videos[currVideoIndex].type === "youtube_url" ? (
                          <div className="product_video_player">
                            <ReactPlayer
                              className="react-player"
                              playing={playing}
                              url={videos[currVideoIndex].url}
                              width="92%"
                              height="100%"
                              controls={false}
                            />
                          </div>
                        ) : (
                          <a
                            target="_blank"
                            href={videos[currVideoIndex].url}
                            style={{ position: "relative" }}
                          >
                            <div
                              className="product_video_player"
                              style={{
                                background: "#D4D5D4",
                                opacity: 0.7,
                                borderRadius: "5px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <RiDownload2Line size={20} />
                            </div>
                          </a>
                        )}
                      </div>
                    )}
                    <div
                      style={{
                        width: "35vw",
                        maxWidth: "550px",
                      }}
                    >
                      <Carousel
                        responsive={product_video_responsive}
                        autoPlay={false}
                        infinite={true}
                        focusOnSelect={false}
                        showDots={false}
                        arrows={true}
                      >
                        {videos.map((el, id) =>
                          (el?.format && el?.format === "mp4") ||
                          el.type === "youtube_url" ? (
                            <div
                              style={{
                                position: "relative",
                                margin: "15px 1% 15px 0",
                                height: "95px",
                                width: "95px",
                                backgroundImage:
                                  "linear-gradient(rgb(218, 223, 225), rgb(236, 240, 241))",
                                borderRadius: "7px",
                                overflow: "hidden",
                              }}
                              onClick={() => {
                                this.handlePlayYoutubeAndMp4(el, id);
                              }}
                            >
                              <img
                                style={{
                                  position: "absolute",
                                  height: "100%",
                                  width: "100%",
                                  objectFit: "fill",
                                  zIndex: 0,
                                }}
                                src={
                                  el?.thumbnail
                                    ? el.thumbnail
                                    : product.logo_url === undefined
                                    ? product.product_logo_url === undefined
                                      ? imageURL
                                      : product.product_logo_url
                                    : product.logo_url
                                }
                              />
                              <div
                                style={{
                                  position: "absolute",
                                  zIndex: 1,
                                  height: "100%",
                                  width: "100%",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  border: 0,
                                }}
                              >
                                <img
                                  style={{
                                    height: "20px",
                                    width: "20px",
                                    zIndex: 1,
                                    border: 0,
                                  }}
                                  src={
                                    currVideoIndex === id
                                      ? playing
                                        ? pause
                                        : play
                                      : play
                                  }
                                />
                              </div>
                            </div>
                          ) : (
                            <a
                              target="_blank"
                              href={el.url}
                              style={{ marginRight: "10px" }}
                            >
                              <div
                                style={{
                                  position: "relative",
                                  margin: "15px 1% 15px 0",
                                  height: "95px",
                                  width: "95px",
                                  backgroundImage:
                                    "linear-gradient(rgb(218, 223, 225), rgb(236, 240, 241))",
                                  borderRadius: "7px",
                                  overflow: "hidden",
                                }}
                                onClick={() => {
                                  this.setState({
                                    show_product_image_only: false,
                                    currVideoIndex: id,
                                  });
                                }}
                              >
                                <img
                                  style={{
                                    position: "absolute",
                                    height: "100%",
                                    width: "100%",
                                    objectFit: "fill",
                                    zIndex: 0,
                                    opacity: 0.5,
                                  }}
                                  src={
                                    el?.thumbnail
                                      ? el.thumbnail
                                      : product.logo_url === undefined
                                      ? product.product_logo_url === undefined
                                        ? imageURL
                                        : product.product_logo_url
                                      : product.logo_url
                                  }
                                />
                                <div
                                  style={{
                                    position: "absolute",
                                    zIndex: 1,
                                    height: "100%",
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    border: 0,
                                  }}
                                >
                                  <RiDownload2Line />
                                </div>
                              </div>
                            </a>
                          )
                        )}
                      </Carousel>
                    </div>
                  </div>
                ) : (
                  <img
                    className="product_video_player"
                    style={{
                      width: "32vw",
                      maxWidth: "550px",
                      objectFit: "contain",
                    }}
                    src={
                      product.logo_url === undefined
                        ? product.product_logo_url === undefined
                          ? imageURL
                          : product.product_logo_url
                        : product.logo_url
                    }
                  />
                )}
              </div>

              <div className="productDescRight">
                <div className="productDescLeftDetail" style={{}}>
                  <h1>{product.title}</h1>

                  <h3 style={{ display: "flex" }}>
                    {product.is_paid === "N" ? (
                      <div>Free &nbsp;&nbsp;</div>
                    ) : (
                      (product.c_code || product.country_details?.currency_code || "") +
                      " " +
                      (product.price === undefined
                        ? product.actual_price
                        : product.price)
                    )}
                    {product.discount_percentage > 0 && (
                      <span className="discount">
                        {" "}
                        {product.c_code
                          ? product.c_code
                          : ""}{" "}
                        {product.price_before_discount}
                      </span>
                    )}
                    {product.discount_percentage > 0 && (
                      <span
                        className="otherTag"
                        style={{
                          color: "green",
                          fontWeight: 700,
                          paddingLeft: 6,
                          paddingRight: 10,
                        }}
                      >
                        {" "}
                        {product.discount_percentage} % off on product
                      </span>
                    )}
                    <div className="otherTag">
                      &nbsp;&nbsp;&nbsp;
                      {product.offer_available && (
                        <div>
                          <img src={OfferTag} />
                          <h5 style={{ color: colors.CRUSTA }}>
                            Offers Available
                          </h5>
                        </div>
                      )}
                      {product.purchase_count_status !== 0 &&
                        (product.total_prod_purchaseed > 0 ||
                          product.total_product_sold > 0) && (
                          <h2
                            style={{
                              color: colors.PICTON_BLUE,
                              marginTop: "2px",
                            }}
                          >
                            {product.total_prod_purchaseed === undefined
                              ? product.total_product_sold
                              : product.total_prod_purchaseed}{" "}
                            Student(s) Purchased
                          </h2>
                        )}
                    </div>
                  </h3>
                  {this.props.site_data?.enable_instalment_payment && this.state.instalmentPlan.length > 0 && !product.is_enrolled && (() => {
                    const selectedTotal = this.state.instalmentPlan
                      .filter((_, idx) => this.state.selectedInstalments.includes(idx + 1))
                      .reduce((sum, inst) => sum + Number(inst.amount), 0);
                    const cc = product.c_code ? product.c_code : "";
                    return (
                      <p
                        style={{
                          fontSize: 13,
                          color: "#4CAF50",
                          fontWeight: 600,
                          margin: "4px 0 8px",
                        }}
                      >
                        Pay {this.state.selectedInstalments.length} of{" "}
                        {this.state.instalmentPlan.length} installments: {cc}{" "}
                        {selectedTotal.toFixed(2)}
                      </p>
                    );
                  })()}

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    {(() => {
                      const cartId = from_direct_url ? product.product_id : product.id;
                      const isInCart = cart && cart.includes(cartId);
                      const canPurchase = from_direct_url ? !product.sold_out : (product.remaining_products > 0 && !product.is_enrolled);
                      return (
                        <>
                          {isInCart && (
                            <button
                              style={{
                                marginRight: 4,
                                color: colors.CARDINAL,
                                borderColor: colors.CARDINAL,
                              }}
                              onClick={() =>
                                this.removeFromCart(product, from_direct_url)
                              }
                            >
                              Remove from Cart <i className="fa fa-remove"></i>
                            </button>
                          )}

                          {!isInCart && canPurchase && (
                            <button
                              style={{ marginRight: 4 }}
                              onClick={() =>
                                this.addToCart(product, from_direct_url)
                              }
                            >
                              Add to Cart <i className="fa fa-shopping-cart"></i>
                            </button>
                          )}

                          {canPurchase && (
                            <button
                              style={{ marginRight: 4, marginLeft: 10 }}
                              onClick={() => {
                                this.addToCart(product, from_direct_url);
                                this.props.history.push("/cart");
                              }}
                            >
                              Buy Now
                            </button>
                          )}
                        </>
                      );
                    })()}

                    {product.remaining_products === 0 &&
                      !product.is_enrolled && (
                        <button
                          disabled={true}
                          style={{
                            marginRight: 4,
                            color: colors.CRUSTA,
                            borderColor: colors.CRUSTA,
                            fontWeight: 700,
                            borderWidth: 0,
                            paddingLeft: 0,
                          }}
                        >
                          Sold Out
                        </button>
                      )}

                    {from_direct_url && product.sold_out && (
                      <button
                        disabled={true}
                        style={{
                          marginRight: 4,
                          color: colors.CRUSTA,
                          borderColor: colors.CRUSTA,
                          fontWeight: 700,
                          borderWidth: 0,
                          paddingLeft: 0,
                        }}
                      >
                        Sold Out
                      </button>
                    )}

                    {product.is_enrolled && (
                      <button
                        disabled={true}
                        style={{
                          marginRight: 4,
                          color: colors.JADE,
                          borderColor: colors.JADE,
                          fontWeight: 700,
                          borderWidth: 0,
                          paddingLeft: 0,
                        }}
                      >
                        <i className="fa fa-check" style={{ padding: 0 }}></i>{" "}
                        Purchased
                      </button>
                    )}
                  </div>
                </div>
                <div className="productDetail">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <h1>About</h1>
                  </div>
                  <p
                    className="productDetailsList"
                    dangerouslySetInnerHTML={{ __html: product.about }}
                  ></p>
                </div>

              </div>
            </div>
          </div>
        )}

        {/* Installment Plan Section */}
        {this.props.site_data?.enable_instalment_payment && !loader && success && !loader1 && success1 && !loader3 && this.state.instalmentPlan.length > 0 && (() => {
          const isPurchased = product.is_enrolled;
          const hasPending = this.state.instalmentPlan.some(
            (inst) => inst.status === 10 || inst.status === 30
          );
          const cc = product.c_code ? product.c_code : "";
          return (
            <div
              style={{
                paddingBottom: 10,
                position: "relative",
                zIndex: 999,
              }}
            >
              <div
                style={{
                  maxWidth: "1200px",
                  margin: "30px auto",
                  padding: "0 20px",
                  position: "relative",
                  zIndex: 10,
                  backgroundColor: "#fff",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    cursor: "pointer",
                    marginBottom: 20,
                  }}
                  onClick={() =>
                    this.setState({
                      instalmentPlanExpanded: !this.state.instalmentPlanExpanded,
                    })
                  }
                >
                  <h1 style={{ marginBottom: 0, fontSize: "28px" }}>
                    Installment Plan
                    {isPurchased && (() => {
                      const paid = this.state.instalmentPlan.filter((inst) => inst.status === 20).length;
                      const total = this.state.instalmentPlan.length;
                      const hasOverdue = this.state.instalmentPlan.some((inst) => inst.status === 30);
                      let badgeColor = "#ff9800";
                      if (paid === total) badgeColor = "#4CAF50";
                      if (hasOverdue) badgeColor = "#f44336";
                      return (
                        <span
                          style={{
                            backgroundColor: badgeColor,
                            color: "#fff",
                            padding: "2px 8px",
                            borderRadius: 4,
                            fontSize: 10,
                            fontWeight: 600,
                            marginLeft: 8,
                            verticalAlign: "middle",
                          }}
                        >
                          {paid}/{total} Paid
                        </span>
                      );
                    })()}
                  </h1>
                  <i
                    className={
                      this.state.instalmentPlanExpanded
                        ? "fa fa-chevron-up"
                        : "fa fa-chevron-down"
                    }
                  ></i>
                </div>
                {this.state.instalmentPlanExpanded && (
                  <InstalmentSchedule
                    instalments={this.state.instalmentPlan}
                    purchased={!!isPurchased}
                    selectable={isPurchased ? hasPending : true}
                    selectedInstalments={this.state.selectedInstalments}
                    onSelectionChange={(selected) =>
                      this.setState({ selectedInstalments: selected })
                    }
                    onPayNext={
                      isPurchased && hasPending
                        ? (selectedNums, selectedTotal) =>
                            this.handlePayInstalment(selectedNums, selectedTotal)
                        : undefined
                    }
                    currencyCode={cc}
                  />
                )}
              </div>
            </div>
          );
        })()}

        {/* Bottom Section: Product Details Accordion - OUTSIDE main content div */}
        {showProductDetails && !loader && success && !loader1 && success1 && !loader3 && desc && desc.length > 0 && (
          <div
            style={{
              paddingBottom: 30,
              position: "relative",
              zIndex: 999,
            }}
          >
            {desc && desc.length > 0 && (
              <div
                style={{
                  maxWidth: "1200px",
                  margin: "30px auto",
                  padding: "0 20px",
                  position: "relative",
                  zIndex: 10,
                  backgroundColor: "#fff",
                }}
              >
                <h1 style={{ marginBottom: "20px", fontSize: "28px" }}>
                  Product Details
                </h1>
                <div>
                {Array.isArray(desc) && desc.length > 0 ? (
  desc.map((item, i) => {
  
                    return (
                    <div
                      key={i}
                      style={{
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                        marginBottom: "10px",
                        overflow: "hidden",
                        backgroundColor: "#fff",
                        position: "relative",
                        zIndex: 1,
                      }}
                    >
                      {/* Accordion Header */}
                      <div
                        onClick={() => {
                          this.toggleItemExpansion(i);
                        }}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "15px 20px",
                          cursor: "pointer",
                          backgroundColor: expandedItems[i] ? "#f8f9fa" : "#fff",
                          transition: "background-color 0.3s ease",
                          userSelect: "none",
                          pointerEvents: "auto",
                        }}
                      >
                        <div>
                          <h5 style={{ margin: 0, fontSize: "18px", fontWeight: 600 }}>
                            {item.name || "Unnamed Item"}
                          </h5>
                          {item.slug_type && !expandedItems[i] && (
                            <p style={{ margin: "5px 0 0 0", fontSize: "14px", color: "#666" }}>
                              {item.slug_type}
                            </p>
                          )}
                        </div>
                        <div
                          style={{
                            fontSize: "24px",
                            fontWeight: "bold",
                            color: colors.PICTON_BLUE,
                            transition: "transform 0.3s ease",
                            transform: expandedItems[i] ? "rotate(45deg)" : "rotate(0deg)",
                          }}
                        >
                          +
                        </div>
                      </div>

                      {/* Accordion Content */}
                      {expandedItems[i] && (
                        <div
                          style={{
                            padding: "15px 20px",
                            backgroundColor: "#f8f9fa",
                            borderTop: "1px solid #ddd",
                          }}
                        >
                          {item.slug_type && (
                            <p style={{ margin: "8px 0" }}>
                              <strong>Type:</strong> {item.slug_type}
                            </p>
                          )}
                          {item.topic_nm && (
                            <p style={{ margin: "8px 0" }}>
                              <strong>Topic:</strong> {item.topic_nm}
                            </p>
                          )}
                          {item.strd_nm && (
                            <p style={{ margin: "8px 0" }}>
                              <strong>Standard:</strong> {item.strd_nm}
                            </p>
                          )}
                          {item.sub_nm && (
                            <p style={{ margin: "8px 0" }}>
                              <strong>Subject:</strong> {item.sub_nm}
                            </p>
                          )}
                         
                        </div>
                      )}
                    </div>
                    );
                  })
                ) : (
                  <div style={{ textAlign: "center", padding: 20, color: "#666" }}>
                    No product content available yet.
                  </div>
                )}
                </div>
              </div>
            )}
          </div>
        )}

        {/* Live Classes Section */}
        {!loader && success && !loader1 && success1 && !loader3 && filteredLiveClasses.length > 0 && (
          <div
            style={{
              paddingBottom: 30,
              position: "relative",
              zIndex: 999,
            }}
          >
            <div
              style={{
                maxWidth: "1200px",
                margin: "30px auto",
                padding: "0 20px",
                position: "relative",
                zIndex: 10,
                backgroundColor: "#fff",
              }}
            >
              <h1 style={{ marginBottom: "20px", fontSize: "28px" }}>
                Live Classes
              </h1>
              <div>
              {filteredLiveClasses.length > 0 ? (
  filteredLiveClasses.map((liveClass, i) => {
    return (
                  <div
                    key={i}
                    style={{
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      marginBottom: "10px",
                      overflow: "hidden",
                      backgroundColor: "#fff",
                      position: "relative",
                      zIndex: 1,
                    }}
                  >
                    {/* Accordion Header */}
                    <div
                      onClick={() => {
                        this.toggleLiveClassExpansion(i);
                      }}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "15px 20px",
                        cursor: "pointer",
                        backgroundColor: expandedLiveClasses[i] ? "#f8f9fa" : "#fff",
                        transition: "background-color 0.3s ease",
                        userSelect: "none",
                        pointerEvents: "auto",
                      }}
                    >
                      <div>
                        <h5 style={{ margin: 0, fontSize: "18px", fontWeight: 600 }}>
                          {liveClass.topic || "Unnamed Live Class"}
                        </h5>
                        {liveClass.start_datetime && !expandedLiveClasses[i] && (
                          <p style={{ margin: "5px 0 0 0", fontSize: "14px", color: "#666" }}>
                            {new Date(liveClass.start_datetime).toLocaleDateString()} | {liveClass.class_type}
                          </p>
                        )}
                      </div>
                      <div
                        style={{
                          fontSize: "24px",
                          fontWeight: "bold",
                          color: colors.PICTON_BLUE,
                          transition: "transform 0.3s ease",
                          transform: expandedLiveClasses[i] ? "rotate(45deg)" : "rotate(0deg)",
                        }}
                      >
                        +
                      </div>
                    </div>

                    {/* Accordion Content */}
                    {expandedLiveClasses[i] && (
                      <div
                        style={{
                          padding: "15px 20px",
                          backgroundColor: "#f8f9fa",
                          borderTop: "1px solid #ddd",
                        }}
                      >
                        {liveClass.class_type && (
                          <p style={{ margin: "8px 0" }}>
                            <strong>Type:</strong> {liveClass.class_type}
                          </p>
                        )}
                        {liveClass.c_nm && (
                          <p style={{ margin: "8px 0" }}>
                            <strong>Batch:</strong> {liveClass.c_nm}
                          </p>
                        )}
                        {liveClass.mc_nm && (
                          <p style={{ margin: "8px 0" }}>
                            <strong>Course:</strong> {liveClass.mc_nm}
                          </p>
                        )}
                        {liveClass.start_datetime && (
                          <p style={{ margin: "8px 0" }}>
                            <strong>Start Time:</strong> {new Date(liveClass.start_datetime).toLocaleString()}
                          </p>
                        )}
                        {liveClass.end_datetime && (
                          <p style={{ margin: "8px 0" }}>
                            <strong>End Time:</strong> {new Date(liveClass.end_datetime).toLocaleString()}
                          </p>
                        )}

                      </div>
                    )}
                  </div>
                 );
                })
              ) : (
                <div style={{ textAlign: "center", padding: 20, color: "#666" }}>
                  No live classes available.
                </div>
              )}
              </div>
            </div>
          </div>
        )}

        {(loader || loader1 || loader3 || paymentLoader) && (
          <div className="content">
            <div className="loading"></div>
          </div>
        )}

        {!loader && !loader1 && !loader3 && (!success || !success1) && (
          <ErrorPage
            onReload={() => {
              this.setState({ loader: true, loader1: true });
              this.getProdDesc();
              this.getProdDetails();
            }}
            message={""}
          />
        )}

        <Footer />
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return { ...state.cart, ...state.auth, ...state.home };
};

export default connect(mapStateToProps)(withRouter(ProductDesc));
